import { searchCustomerDisplaySettings } from 'api/core'

const TRUE_VALUES = ['true', 'active', 'activo', 'enabled', 'habilitado', '1']
const FALSE_VALUES = [
  'false',
  'inactive',
  'inactivo',
  'disabled',
  'deshabilitado',
  '0',
]

const getBooleanValue = value => {
  if (typeof value === 'boolean') return value
  if (typeof value === 'number') return value > 0
  if (typeof value !== 'string') return undefined

  const normalizedValue = value.trim().toLowerCase()
  if (TRUE_VALUES.includes(normalizedValue)) return true
  if (FALSE_VALUES.includes(normalizedValue)) return false

  return undefined
}

const getSettingValue = (setting, key) => {
  if (Object.prototype.hasOwnProperty.call(setting, key)) return setting[key]

  const normalizedKey = key.toLowerCase()
  const matchedKey = Object.keys(setting).find(
    settingKey => settingKey.toLowerCase() === normalizedKey
  )

  return matchedKey ? setting[matchedKey] : undefined
}

const getSettingStatus = setting => {
  if (!setting || typeof setting !== 'object') return undefined

  const statusKeys = [
    'IsEnabled',
    'Enabled',
    'IsActive',
    'Active',
    'Status',
    'CustomerDisplayEnabled',
    'IsCustomerDisplayEnabled',
    'Value',
    'SettingValue',
  ]

  for (const key of statusKeys) {
    const status = getBooleanValue(getSettingValue(setting, key))
    if (status !== undefined) return status
  }

  return undefined
}

const hasActiveCustomerDisplaySetting = settings => {
  if (!Array.isArray(settings)) return false
  if (settings.length === 0) return false

  const statuses = settings
    .map(setting => getSettingStatus(setting))
    .filter(status => status !== undefined)

  return statuses.some(Boolean)
}

export const isCustomerDisplayMasterEnabled = async ({
  CompanyId,
  BranchOfficeId,
}) => {
  if (!CompanyId || !BranchOfficeId) return false

  const response = await searchCustomerDisplaySettings({
    CompanyId,
    BranchOfficeId,
    PageNumber: 1,
    PageSize: 100,
  })
  const data = response?.data?.Data

  if (Array.isArray(data)) {
    return hasActiveCustomerDisplaySetting(data)
  }

  const dataStatus = getSettingStatus(data)
  if (dataStatus !== undefined) return dataStatus

  return hasActiveCustomerDisplaySetting(
    data?.Items || data?.Results || data?.Records
  )
}
